<template>
  <div class="site-choose">
    <span class="go-back" @click="goBack"><i class="el-input__icon el-icon-arrow-left"></i>返回</span>
    <div class="product-list">
      <div class="product-box">
        <div
          :class="[
            'product-item',
            { active: currentProduct.enName === product.enName },
            { editable: countCheckedNum(product.enName) },
          ]"
          v-for="(product, index) of choicedProducts"
          :key="index"
        >
          <span class="product-name">{{ product.name }}</span>
          <span class="edit-btn" @click.stop="editorProduct(product.enName)">编辑内容</span>
          <div class="cards" v-if="product.enName === 'poster'" @click="checkProduct(product)">
            <div class="poster-card" v-for="(logoInfo, index) of posterData.logos" :key="index">
              <poster
                style="transform: scale(0.6); transform-origin: 0 0"
                :size="posterData.size"
                :elConfig="posterData.elementInfo"
                :bgConfig="posterData.bgParameter"
                :elementImg="posterData.elementImg"
                :textInfo="posterData.textInfo"
                :contentStyle="posterData.contentStyle"
                :posterTextMaps="posterTextMaps"
                :logo="logoInfo"
              />
            </div>
            <div class="no-data" v-if="!posterData.logos.length">点击添加业务线logo</div>
          </div>
          <div class="cards" v-if="product.enName === 'banner'" @click="checkProduct(product)">
            <div class="cards-inner">
              <div
                class="banner-card"
                v-for="bannerData of bannerDataList"
                :key="bannerData.sizeId"
                :style="{
                  width: bannerData.size.width * 0.6 + 'px',
                  height: bannerData.size.height * 0.6 + 'px',
                }"
              >
                <banner
                  style="transform: scale(0.6); transform-origin: 0 0"
                  :bannerName="bannerData.sizeName"
                  :size="bannerData.size"
                  :bannerTextValue="bannerData.textValue"
                  :bgConfig="bannerData.bgParameter"
                  :elementImg="bannerData.elementImg"
                  :textInfo="bannerData.textInfo"
                  :textStyle="bannerData.textStyle"
                  :elConfig="bannerData.elementInfo"
                />
              </div>
              <div class="no-data" v-if="!bannerDataList.length">点击选择{{ product.name }}尺寸</div>
            </div>
          </div>
          <div class="cards" v-if="product.enName === 'cover'" @click="checkProduct(product)">
            <div class="cover-card" v-for="(cover, index) of coverDataList" :key="index">
              <cover
                :id="'cover' + index"
                :bgConfig="cover.bgParameter"
                :elementImg="cover.elementImg"
                :size="cover.size"
                :elConfig="cover.elementInfo"
                :textConfig="cover.textInfo"
                :fontStyles="cover.fontStyles"
              />
            </div>
            <div class="no-data" v-if="!coverDataList.length">点击选择{{ product.name }}尺寸</div>
          </div>
          <span class="choice-num" v-if="countCheckedNum(product.enName)"
            >已选中{{ countCheckedNum(product.enName) }}张</span
          >
          <span class="choice-icon"></span>
        </div>
      </div>
    </div>
    <div class="right-panel">
      <span class="product-name">{{ currentProduct.name }}</span>
      <poster-site-choice
        v-if="currentProduct.enName === 'poster'"
        theme="dark"
        @pickSite="pickPosterSite"
        :logoOptions="logoOptions"
        :selectedSiteIds="posterData.logos.map(item => item.id)"
      />
      <banner-site-size
        v-if="currentProduct.enName === 'banner'"
        theme="dark"
        :sizes="allBannerSizes"
        ref="siteSize"
        @addBannerSize="checkBannerSize"
        @removeBannerSize="removeBannerSize"
      />
      <cover-site-size v-if="currentProduct.enName === 'cover'" />
    </div>
    <div class="download-wrap">
      <poster
        v-for="(logoInfo, index) of posterData.logos"
        :key="'poster' + index"
        :id="'poster' + index"
        :size="posterData.size"
        :elConfig="posterData.elementInfo"
        :bgConfig="posterData.bgParameter"
        :elementImg="posterData.elementImg"
        :textInfo="posterData.textInfo"
        :contentStyle="posterData.contentStyle"
        :posterTextMaps="posterTextMaps"
        :logo="logoInfo"
      />
      <banner
        v-for="(bannerData, index) of bannerDataList"
        :key="'banner' + index"
        :id="'banner' + index"
        :bannerName="bannerData.sizeName"
        :size="bannerData.size"
        :bannerTextValue="bannerData.textValue"
        :bgConfig="bannerData.bgParameter"
        :elementImg="bannerData.elementImg"
        :textInfo="bannerData.textInfo"
        :textStyle="bannerData.textStyle"
        :elConfig="bannerData.elementInfo"
      />
    </div>
    <button v-show="downLoadTotal" class="download-btn ai-btn">
      <span v-if="isDownLoading" class="loading-icon"></span>
      <span v-else @click="downLoad" class="download-text">整套下载({{ downLoadTotal }})</span>
      <span v-if="downLoadTotal > 9" class="download-tips">为提升下载效率，将为您多包下载</span>
    </button>
  </div>
</template>
<script>
import { downloadBase64Pile } from "@/assets/scripts/utils.js";
import coverSiteSize from "@/pages/ai/components/cover-size.vue";
import banner from "@/pages/banner/components/banner.vue";
import bannerSiteSize from "@/pages/banner/components/site-size.vue";
import { genBannerDataBySize, saveBannerToBase } from "@/pages/banner/js/banner-feature";
import cover from "@/pages/cover/components/cover.vue";
import { saveCoverToBase } from "@/pages/cover/js/cover-feature";
import poster from "@/pages/poster/components/poster-long.vue";
import posterSiteChoice from "@/pages/poster/components/site-choice.vue";
import { getLogos, savePosterLongToBase } from "@/pages/poster/js/poster-feature";
import { mapMutations, mapState } from "vuex";
export default {
  name: "siteChoose",
  data() {
    return {
      currentProduct: {},
      // 是否正在下载
      isDownLoading: false,
      // 正在保存
      isSaving: false,
      // 某个封面合法输入
      legalInput: true,
    };
  },
  components: {
    cover,
    banner,
    poster,
    posterSiteChoice,
    bannerSiteSize,
    coverSiteSize,
  },
  async mounted() {
    this.currentProduct = this.choicedProducts[0];
    // 请求logo数据
    const logoOptions = await getLogos();
    this.setLogos(logoOptions);
  },
  computed: {
    ...mapState("cover", ["coverDataList", "coverData"]),
    ...mapState("posterLong", ["posterTextMaps", "posterData"]),
    ...mapState("banner", ["bannerDataList", "bannerData"]),
    ...mapState("ai", ["products", "allBannerSizes", "aiKeywords", "contentStyles", "logoOptions"]),
    // 被选中的产品
    choicedProducts() {
      return this.products.filter(product => product.isShow);
    },
    // 下载总数
    downLoadTotal() {
      return this.coverDataList.length + this.posterData.logos.length + this.bannerDataList.length;
    },
  },
  methods: {
    ...mapMutations("cover", ["updateCoverDataList", "updateCoverData", "deleteCoverData"]),
    ...mapMutations("posterLong", ["updatePosterData", "updatePosterTextMaps"]),
    ...mapMutations("ai", ["setLogos"]),
    ...mapMutations("banner", ["addBannerSize", "removeBannerSize", "addBannerDataList"]),
    editorProduct(productName) {
      if (productName === "banner") {
        this.$router.push(`/ai/banner-editor`);
      }
      if (productName === "poster") {
        this.$router.push(`/ai/poster-editor`);
      }
      if (productName === "cover") {
        this.$router.push(`/ai/cover-editor`);
      }
    },
    // 选中站点｜去掉站点 相关posterData
    pickPosterSite(siteId) {
      const selectedLogos = new Set(this.posterData.logos);
      const logoInfo = this.logoOptions.find(item => item.id === siteId);
      if (selectedLogos.has(logoInfo)) {
        selectedLogos.delete(logoInfo);
      } else {
        selectedLogos.add(logoInfo);
      }
      this.updatePosterData({
        logos: [...selectedLogos],
      });
    },
    checkBannerSize(sizeItem) {
      // 如果bannerInfo中没有textValue，则使用this.bannerData的textValue
      const bannerInfo = genBannerDataBySize(sizeItem);
      bannerInfo.textStyle.forEach((item, index) => {
        if (bannerInfo.type === 1) {
          bannerInfo.textStyle[index].labelStyle = "";
          bannerInfo.textStyle[index].showLabelStyle = false;
        } else {
          const textStyle = this.bannerData.textStyle[index];
          item.showLabelStyle = textStyle.showLabelStyle;
          item.labelStyle = textStyle.labelStyle;
        }
      });
      this.addBannerDataList({
        ...JSON.parse(JSON.stringify(this.bannerData)),
        ...bannerInfo,
      });
    },
    // 下载并保存
    async downLoad() {
      if (this.isDownLoading) return;
      this.isDownLoading = true;
      const arr = [];
      if (this.posterData.logos.length) {
        arr.push({
          name: "poster",
          datas: this.posterData.logos,
        });
        // 提交用户设计
        savePosterLongToBase(this.posterData, this.posterTextMaps);
      }
      if (this.bannerDataList.length) {
        arr.push({
          name: "banner",
          datas: this.bannerDataList,
        });
        debugger;
        // 提交用户设计
        saveBannerToBase(this.bannerDataList);
      }
      if (this.coverDataList.length) {
        arr.push({
          name: "cover",
          datas: this.coverDataList,
        });
        // 提交用户设计
        saveCoverToBase(this.coverDataList);
      }
      const downData = await downloadBase64Pile(arr);
      if (downData.code === 10000) {
        this.$message.success("下载成功");
      }
      // this.$router.push("/");
      this.isDownLoading = false;
    },
    // 切换产品选择尺寸
    checkProduct(product) {
      this.currentProduct = product;
    },
    // 计算选中数量
    countCheckedNum(productName) {
      const dataListMap = {
        poster: this.posterData.logos,
        banner: this.bannerDataList,
        cover: this.coverDataList,
      };
      return dataListMap[productName]?.length || 0;
    },
    goBack() {
      this.$router.push(`/ai/generate?words=${this.aiKeywords}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.site-choose {
  position: relative;
  padding: 24px;
  height: calc(100vh - 60px);
  background: #020202;
  .go-back {
    position: absolute;
    z-index: 10;
    top: 24px;
    left: 24px;
    color: #fff;
    font-size: 16px;
    width: 78px;
    height: 32px;
    line-height: 32px;
    padding-left: 6px;
    text-align: left;
    cursor: pointer;
    border-radius: 16px 0 16px 0px;
    background: #181b24;
    .el-icon-arrow-left {
      line-height: 32px;
    }
    &:hover {
      background: linear-gradient(0deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 100%), #181b24;
    }
  }
  .product-list {
    position: relative;
    padding: 48px 0 0px;
    height: 100%;
    width: calc(100% - 424px);
    background: rgba(33, 37, 49, 0.9);
    border-radius: 16px;
    .product-box {
      padding: 0 80px;
      height: calc(100% - 60px);
      overflow: auto;
    }
    .product-item {
      position: relative;
      margin: 48px 0 78px;
      .cards {
        padding: 24px 24px 40px;
        display: flex;
        flex-wrap: wrap;
        gap: 24px;
        border-radius: 8px;
        background: #8569d9;
        &:before,
        &:after {
          content: "";
          position: absolute;
          top: 1px;
          left: 1px;
          right: 1px;
          bottom: 1px;
          border-radius: 8px;
          background: #242931;
        }
        &:after {
          z-index: 0;
          background: #242931;
        }
        .cards-inner {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          gap: 24px;
          overflow-x: auto;
          padding-bottom: 10px;
        }
      }
      .product-name {
        position: absolute;
        top: -48px;
        left: 0;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.6);
        font-size: 16px;
        font-weight: 500;
      }
      .poster-card {
        height: 400px;
        width: 225px;
      }
      .choice-icon {
        display: none;
        position: absolute;
        z-index: 3;
        bottom: 0;
        right: 0;
        width: 44px;
        height: 28px;
        background: url("./icon/ai-check.png") no-repeat center;
        background-size: 100% 100%;
      }
      .choice-num {
        position: absolute;
        z-index: 3;
        bottom: 4px;
        right: 48px;
        color: #99ceff;
        font-size: 14px;
        line-height: 22px;
      }
      .edit-btn {
        display: none;
        position: absolute;
        width: 112px;
        padding-right: 16px;
        text-align: right;
        height: 31px;
        line-height: 31px;
        z-index: 3;
        top: -31px;
        right: 0;
        color: #fff;
        font-size: 15px;
        background: url(./icon/edit-bg.png) no-repeat center center;
        background-size: 100% 100%;
      }
      &:hover,
      &.active {
        .cards {
          background: linear-gradient(90deg, #8569d9, #43bbff, #8093f7);
          &:after {
            background: linear-gradient(295deg, rgba(122, 85, 232, 0.2) -2.91%, rgba(23, 143, 255, 0.2) 89.83%);
          }
        }
        .product-name {
          color: #767de2;
        }
      }
      &.active {
        // .choice-icon {
        //   display: block;
        // }
      }
      &.editable {
        .cards {
          border-radius: 8px 0 8px 8px;
          &:before,
          &:after {
            border-radius: 8px 0 8px 8px;
          }
        }
        .choice-icon {
          display: block;
        }
        .edit-btn {
          cursor: pointer;
          display: block;
        }
      }
    }
  }
}
.cover-card {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}
.input-area {
  width: 500px;
}
.download-wrap {
  padding: 24px;
  overflow: hidden;
  z-index: -1;
}
.right-panel {
  position: fixed;
  top: 84px;
  bottom: 24px;
  right: 24px;
  padding: 24px;
  width: 400px;
  background: rgba(33, 37, 49, 0.9);
  border-radius: 16px;
  overflow: auto;
  .product-name {
    margin-bottom: 24px;
    display: block;
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }
}
.download-btn {
  position: fixed;
  bottom: 48px;
  right: 48px;
  z-index: 1000;
  width: 352px;
  .download-text {
    display: block;
    height: 100%;
    line-height: 50px;
    cursor: pointer;
  }
  .download-tips {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 274px;
    height: 66px;
    color: #99ceff;
    font-size: 15px;
    line-height: 46px;
    background: url(./icon/tip-bg.png) no-repeat 0 0;
    background-size: 100% auto;
  }
}
.no-data {
  position: relative;
  z-index: 2;
  color: rgba(255, 255, 255, 1);
  height: 210px;
  line-height: 210px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  flex: 1;
  cursor: pointer;
}
</style>
